export default "__VITE_ASSET__0V5ZaSjw__"